import { useMemo } from 'react';
import dayjs from 'dayjs';

import { transformExperimentViews } from '../utils';
import { ExperimentViewsFilters } from '@/hooks/constants/keys/experiment';
import { useGetExperimentViews } from '@/hooks/usePlannerQueries/experiment';

export interface CalendarFilters {
  offset?: number;
  limit?: number;
  name?: string;
  state?: string[];
  dates?: dayjs.Dayjs[];
}

export function useCalendarData(filters: CalendarFilters = {}) {
  const { dates, ...rest } = filters;
  const queryFilters: ExperimentViewsFilters = {
    ...rest,
    ...(dates?.length ? { dates: dates.map((d) => d.toISOString()) } : {}),
  };

  const {
    data: experimentViews,
    isLoading,
    error,
    refetch,
  } = useGetExperimentViews(queryFilters, {
    enabled: true,
    staleTime: 5 * 60 * 1000,
  });

  const calendarEvents = useMemo(() => {
    if (!experimentViews?.experiment_views) return [];

    return transformExperimentViews(experimentViews.experiment_views);
  }, [experimentViews]);

  return {
    calendarEvents,
    isLoading,
    error,
    refetch,
    rawData: experimentViews,
  };
}
